export interface AddressValidationResult {
  hasError: boolean;
  errorMessages?: string;
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  zipExtension?: string;
}

// Shape of USPS-validated address
export interface AddressValidationInfo {
  show: boolean;
  customerMappingId?: number; // customer mapping id
  addressMappingId?: number; // address mapping id
  address1?: string;
  address2?: string;
  city?: string;
  state?: string;
  zipCode?: string;
  zipExtension?: string;
}

export const emptyAddressValidationInfo: AddressValidationInfo = {
  show: false,
};